import React, { useState } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Linking, Image, ScrollView } from 'react-native';
import { Feather } from '@expo/vector-icons';
import styles from './styles/styles';  // Import the styles
import Sidebar from './sidebar';  // ✅ Import the new Sidebar
import Footer from './footer'; // ✅ Import Footer
import Header from './header'; // ✅ Import Footer

const SuccessStories = ({ navigation }) => {

  const [activeLink, setActiveLink] = useState('SuccessStories');

  const [showSidebar, setShowSidebar] = useState(false);

  const handleLinkPress = (screen) => {
    setShowSidebar(false); // Close sidebar on navigation
    navigation.navigate(screen);
  };

   const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const successData = [
     {
      heading: 'Agentic AI for Employee Onboarding',
      text: 'Our AI agent automates employee onboarding by coordinating tasks across HR, IT, and Finance. It adapts to your processes, handles decisions intelligently, and minimizes manual effort.',
      image: require('./assets/agenticai.webp'), // Replace with your actual image path
      imagePosition: 'right', // Image on the right
    },
    {
      heading: 'High Throughput Streaming - Real-time Insights at Scale ',
      text: 'Over 10 million messages processed per hour with low latency and zero downtime, enabling real-time insights and seamless operations at scale within a single cluster.',
      image: require('./assets/throughput.webp'), // Replace with your actual image path
      imagePosition: 'right', // Image on the right
    },
    {
      heading: 'Integration 360 - Enabled Self Serving Integrations',
      text: 'Manage 50+ integrations across platforms like Salesforce, Workday, and AWS. Self-service tools empower business users to monitor and resolve issues quickly with real-time Slack alerts.',
      image: require('./assets/360.jpg'), // Replace with your actual image path
      imagePosition: 'left', // Image on the left
    },
    {
      heading: 'API Migration Automation - Saved 1,000+ hours',
      text: 'A Python-based framework utilizes state files to monitor and automate the migration of 40+ APIs per business group across environments to a centralized control plane, ensuring reliable, repeatable processes and minimizing manual effort.',
      image: require('./assets/automation.jpeg'), // Replace with your actual image path
      imagePosition: 'left', // Image on the right
    },
  ];

  return (
    <View style={styles.pageContainer}>
        
        {/* Fixed Header */}
      <View style={styles.fixedHeader}>
         <Header onToggleSidebar={toggleSidebar} />
      </View>

      {showSidebar && (
        <Sidebar
          activeLink={activeLink}
          handleLinkPress={handleLinkPress}
          onClose={() => setShowSidebar(false)}
        />
      )}



       {/* Scrollable content */}
      <ScrollView contentContainerStyle={styles.scrollContent} style={{ marginTop: 60 }}>
      {/* Main Content */}
      <View style={styles.mainContent}>
        <Text style={styles.heading}>Success Stories</Text>

        {/* Success Story Paragraphs with Headings */}
       <View style={styles.paragraphContainer}>
          {successData.map((item, index) => (
            <View key={index} style={styles.storyBlock}>
              <Text style={styles.paragraphHeading}>{item.heading}</Text>
              
               <View style={styles.imageWrapper}>
                  <Image
                    source={item.image} 
                    style={styles.storyImage}
                    resizeMode="cover"
                  />
                </View>
              <Text style={styles.paragraph}>{item.text}</Text>
            </View>
          ))}
        </View>

        {/* Footer */}
        <Footer navigation={navigation} />

      </View>
      </ScrollView>
    </View>
  );
};


export default SuccessStories;
